module.exports = __webpack_public_path__ + "img/order.7b3553b9.svg";